
import * as L from 'leaflet';
import 'leaflet/dist/leaflet.css';

import 'font-awesome/css/font-awesome.min.css'

import 'leaflet-splitmap';

import 'leaflet-sidebar-v2';
import 'leaflet-sidebar-v2/css/leaflet-sidebar.min.css';

import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';

var map = L.map('mapid', {
    center: [51.301, 9.4927],
    doubleClickZoom: false,
    zoom: 14,
    zoomSnap: 0,
    maxZoom: 16,
    minZoom: 11});


var sidebar_control = L.control.sidebar({
    autopan: false,       // whether to maintain the centered map point when opening the sidebar
    closeButton: true,    // whether t add a close button to the panes
    container: 'sidebar', // the DOM container or #ID of a predefined sidebar container that should be used
    position: 'left',     // left or right
});

sidebar_control.addTo(map);
sidebar_control.open('home');

var sentinel = L.tileLayer.wms("https://sgx.geodatenzentrum.de/wms_sentinel2_de",
			                   {layers:"sentinel2-de:rgb_2021",
							    format: 'image/png',
								version: '1.3.0',
								transparent: 'true',
				                attribution: '&copy; Europäische Union, enthält Copernicus Sentinel-2 Daten 2020, verarbeitet durch das Bundesamt für Kartographie und Geodäsie (BKG)'});
sentinel.addTo(map);

var osm = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
		              attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'});
osm.addTo(map)

var vemo = L.tileLayer.wms('https://maps.iee.fraunhofer.de/mapserver/vemosat/mapcache/', 
		                   {layers: "vemo", 
						    format: 'image/png',
							version: '1.3.0',
							transparent: 'true',
			                attribution: '&copy; <a href="https://iee.fraunhofer.de/impressum">Fraunhofer IEE</a> '});
vemo.addTo(map);

var power_110 = L.tileLayer.wms('https://maps.iee.fraunhofer.de/mapserver/vemosat/mapcache/', 
		                        {layers: "powerline_110kv_osm",
								 format: 'image/png',
								 version: '1.3.0',
								 transparent: 'true',
			                     attribution: ''});
power_110.addTo(map);

var power_380 = L.tileLayer.wms('https://maps.iee.fraunhofer.de/mapserver/vemosat/mapcache/', 
		                        {layers: "powerline_380kv_osm", 
								 format: 'image/png',
								 version: '1.3.0',
								 transparent: 'true',
			                     attribution: ''});
power_380.addTo(map);

var base_url = "https://maps.iee.fraunhofer.de/wms/vemosat/?SERVICE=WMS";
var legend_url = base_url + "&VERSION=1.3.0&SLD_VERSION=1.1.0&REQUEST=GetLegendGraphic&FORMAT=image/png&TRANSPARENCY=True&STYLE=&LAYER=";

var overlay = {"Sentinel": sentinel,
               "Vemosat": vemo,
               ['<img src="'+legend_url+'powerline_110kv_osm" />']: power_110,
	           ['<img src="'+legend_url+'powerline_380kv_osm" />']: power_380}

L.control.layers({"OSM": osm}, overlay, {"collapsed": false}).addTo(map);
L.control.splitMap([sentinel], [vemo]).addTo(map);